import templateUrl from "./settings-detail.html";

export const settingsDetailComponent = {
  templateUrl,

  bindings: {
    details: "<",
  },

  controller: class SettingsDetailComponent {
    constructor($state, AdvertisementsService) {
      "ngInject";
      this.$state = $state;
      this.AdvertisementsService = AdvertisementsService;
    }

    $onInit() {
      const days = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
      const formatTime = (value) => {
        if (value === 0) {
          return "12 am";
        } else if (value < 12) {
          return `${value} am`;
        } else if (value === 12) {
          return `${value} pm`;
        } else {
          return `${value - 12} pm`;
        }
      };
      const formatSettingValues = (name, title, values) => {
        return { name, title, values };
      };
      const formatVideoUrl = (setting, title) => {
        return formatSettingValues(setting.name, title, [
          {
            label: "Video URL",
            value:
              setting.value && setting.value.url ? setting.value.url : null,
            isURL: true,
          },
        ]);
      };
      this.settings = this.details.settings.map((setting) => {
        switch (setting.name) {
          case "spouseChecklistVideoUrl":
            return formatVideoUrl(setting, "Spouse Checklist Video");
          case "homeVideoUrl":
            return formatVideoUrl(setting, "Home Video");
          case "timelineVideoUrl":
            return formatVideoUrl(setting, "Timeline Video");
          case "emailNotifications":
            return formatSettingValues(
              setting.name,
              "Inactivity Reminder Email",
              [
                {
                  label: "Enabled",
                  value: setting.value && setting.value.enabled ? "Yes" : "No",
                  isText: true,
                },
                {
                  label: "Days Of Inactivity",
                  value:
                    setting.value && setting.value.inactivityDays
                      ? setting.value.inactivityDays
                      : null,
                  isText: true,
                },
                {
                  label: "Email Content",
                  value:
                    setting.value && setting.value.emailContent
                      ? setting.value.emailContent
                      : null,
                  isHTML: true,
                },
              ]
            );
          case "weeklyNewsletter":
            return formatSettingValues(setting.name, "Weekly Newsletter", [
              {
                label: "Enabled",
                value: setting.value && setting.value.enabled ? "Yes" : "No",
                isText: true,
              },
              {
                label: "Day Of Week",
                value:
                  setting.value && setting.value.dayOfWeek
                    ? days[setting.value.dayOfWeek]
                    : null,
                isText: true,
              },
              {
                label: "Time",
                value:
                  setting.value && setting.value.hour
                    ? `${formatTime(setting.value.hour)} UTC`
                    : null,
                isText: true,
              },
              {
                label: "Advertisement Of The Week",
                value: null,
                isAdvertisement: true,
                isText: true,
              },
            ]);
        }
      });

      // if weekly advertisement given, then fetch the
      // advertisement details
      const weeklyNewsletter = this.details.settings.find(
        (setting) => setting.name === "weeklyNewsletter"
      );
      if (weeklyNewsletter && weeklyNewsletter.value.advertisementId) {
        // fetch advertisement details
        this.AdvertisementsService.getAdvertisementsEditDetails(
          weeklyNewsletter.value.advertisementId
        ).then((details) => {
          // update the advertisement name in the array
          this.settings = this.settings.map((setting) => {
            if (setting.name === weeklyNewsletter.name) {
              setting.values = setting.values.map((data) => {
                if (data.isAdvertisement) {
                  data.value = details.isActive
                    ? details.name
                    : `${details.name} (Inactive)`;
                }
                return data;
              });
            }
            return setting;
          });
        });
      }
    }
    editDetails(settingName) {
      this.$state.go("settingsEdit", { settingName });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/settings/settings-detail/settings-detail.component.js